// Modules
import React from "react";

// theme
import theme from "styles/theme";

// components
import getIcon, { IconProps } from "utils/getIcon";

type ErrorMessageProps = {
	message: string | React.ReactNode;
	hideIcon?: boolean;
	classes?: string;
};

const Icon = (props: IconProps) => getIcon({ ...props });

const ErrorMessage = ({ message, hideIcon = false, classes = "" }: ErrorMessageProps) => {
	return (
		<span className="flex items-start">
			<div>{!hideIcon && <Icon icon="error" iconColor={theme?.colors.red} />}</div>
			<span className={`pl-1 ${classes}`}>{message}</span>
		</span>
	);
};

export default ErrorMessage;
